import { logger } from "./logger";
import { loadScript } from "./../utils/load-script";
import { captureErrorAsync } from "./../utils/capture-error-async";
import { analyticsTrack, analyticsIdentify } from "../utils/analytics";
import { camelCase, mapKeys } from "lodash";

interface Variables {
  orgToken: string;
}

function capturePodiumEvents() {
  window["PodiumEventsCallback"] = (
    event: string,
    properties: Record<string, string>
  ) => {
    if (event === "Conversation Started") {
      analyticsIdentify({
        name: properties["customer-name"],
        phoneNumber: properties["customer-phone"],
      });
    }

    analyticsTrack(event, {
      application: "podium",
      category: "chat",
      ...mapKeys(properties, (_, k) => camelCase(k)),
    });
  };
}

// Will install a script in the format
// <script defer src="https://connect.podium.com/widget.js#ORG_TOKEN=c1bbca90-a9b0-46df-a4b9-2ea6d37f3e22"
// id="podium-widget" data-api-token="c1bbca90-a9b0-46df-a4b9-2ea6d37f3e22"></script>
async function installPodiumScript(orgToken: string) {
  capturePodiumEvents();

  const src = `https://connect.podium.com/widget.js#ORG_TOKEN=${orgToken}`;

  if (window["PodiumWebChat"]) {
    return;
  }

  try {
    await loadScript(src, {
      defer: true,
      id: "podium-widget",
      "data-organization-api-token": orgToken,
    });
    logger.debug(`Successfully loaded Podium script from ${src}`);
  } catch (e) {
    logger.error(`Could not load Podium script from ${src}`);
    captureErrorAsync(e);
  }
}

export function install(variables: Variables, _ctx: FeatureContext): void {
  installPodiumScript(variables.orgToken);
}
